const TechAppDownloadAndroid = () => {
  const androidTechappDownloadUrl = import.meta.env.VITE_TECH_APP_ANDROID_DOWNLOAD_URL || '';

  return (
    <div className="min-h-screen will-change-scroll transform-gpu">
      {/* Hero Section */}
      <div className="py-6 text-center">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Download Tech App (Android)</h1>
          <h2 className="text-xl font-medium">
            Visit this page on your mobile device and follow the instructions below to get started
          </h2>
        </div>
      </div>

      {/* Main Content */}
      <main className="py-6 bg-gray-50">
        <section>
          <div className="container mx-auto px-4 max-w-4xl">
            {/* Step-by-step instructions */}
            <div>
              <ol className="space-y-8">
                {/* Step 1 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>1:</span>
                    <div>
                      <p className={styles.stepTextFirst}>
                        Setup your Okta username and password using the email received during onboarding and the
                        instructions found here:{' '}
                        <p className={styles.stepTextFirst}>
                          <a href="/techapp/login" className={styles.link} style={{color: '#2563eb'}}>
                            {window.location.origin}/techapp/login
                          </a>
                        </p>
                      </p>
                    </div>
                  </div>
                </li>

                {/* Step 2 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>2:</span>
                    <div className="w-full">
                      <p className="text-gray-800 mb-2">Use the button below to download the app:</p>
                      <a
                        href={androidTechappDownloadUrl}
                        className="inline-flex items-center justify-center px-4 py-2 text-base font-bold text-white bg-[#34A853] border-2 border-[#34A853] rounded-lg transition-all duration-200 ease-in-out hover:bg-[#2c8a43] cursor-pointer active:transform-none focus:outline-none focus:ring-2 focus:ring-green-300">
                        Download for Android
                      </a>
                    </div>
                  </div>
                </li>

                {/* Step 3 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>3:</span>
                    <div>
                      <p className={styles.stepText}>Press the &quot;Ok&quot; button to continue the download</p>
                      <img
                        src="/download-tech-app-android/ok.png"
                        alt="Android OK button dialog"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 4 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>4:</span>
                    <div>
                      <p className={styles.stepText}>
                        After the download is complete, press the &quot;Open&quot; button
                      </p>
                      <img
                        src="/download-tech-app-android/open.png"
                        alt="Android Open button dialog"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 5 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>5:</span>
                    <div>
                      <p className={styles.stepText}>
                        Press the &quot;Settings&quot; button and then in the &quot;Security&quot; menu press the
                        checkbox next to &quot;Unknown sources&quot;
                      </p>
                      <div className={styles.multipleImagesContainer}>
                        <img
                          src="/download-tech-app-android/install-blocked.png"
                          alt="Android install blocked dialog"
                          className={styles.image}
                        />
                        <img
                          src="/download-tech-app-android/unknown-sources.png"
                          alt="Android unknown sources settings"
                          className={styles.image}
                        />
                      </div>
                    </div>
                  </div>
                </li>

                {/* Step 6 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>6:</span>
                    <div>
                      <p className={styles.stepText}>
                        On the following pop-up, make sure &quot;Allow this installation only&quot; is checked and then
                        press &quot;Ok&quot;
                      </p>
                      <img
                        src="/download-tech-app-android/this-install-only.png"
                        alt="Android allow this installation only dialog"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 7 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>7:</span>
                    <div>
                      <p className={styles.stepText}>
                        Return to the &quot;Security&quot; menu under &quot;Settings&quot; and make sure the
                        &quot;Unknown Sources&quot; option is unselected to prevent future unauthorized downloads
                      </p>
                      <img
                        src="/download-tech-app-android/disallow-unknown-sources.png"
                        alt="Android disallow unknown sources settings"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>

                {/* Step 8 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>8:</span>
                    <div>
                      <p className={styles.stepText}>Press &quot;Next&quot; and then &quot;Install&quot;</p>
                      <div className={styles.multipleImagesContainer}>
                        <img
                          src="/download-tech-app-android/next-app.png"
                          alt="Android next button in app installation"
                          className={styles.image}
                        />
                        <img
                          src="/download-tech-app-android/install-app.png"
                          alt="Android install app button"
                          className={styles.image}
                        />
                      </div>
                    </div>
                  </div>
                </li>

                {/* Step 9 */}
                <li>
                  <div className={styles.stepContent}>
                    <span className={styles.stepNumber}>9:</span>
                    <div>
                      <p className={styles.stepTextMedium}>
                        You&apos;re all set! Open the Fixt Partner app and start accepting repairs!
                      </p>
                      <img
                        src="/download-tech-app-android/launch-app.png"
                        alt="Android launch app screen"
                        className={styles.image}
                      />
                    </div>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

const styles = {
  stepNumber: 'flex items-start justify-center font-bold mr-4 mt-0',
  stepContainer: '',
  stepContent: 'flex items-start',
  stepText: 'text-gray-900 mb-4',
  stepTextMedium: 'text-gray-900 mb-4 font-medium',
  stepTextFirst: 'text-gray-800 leading-relaxed',
  link: 'font-bold underline',
  image: 'w-56 max-w-full rounded border shadow-sm',
  multipleImagesContainer: 'flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0',
};

export default TechAppDownloadAndroid;
